import React, { useState, useEffect } from "react";
import Logo from "./logo.png";
import { Line } from "react-chartjs-2";
import './App.css';
import contractABI from "./contractABI.json";

import "chart.js/auto"; // Import chart.js

import Web3 from "web3";

function Main() {
  const totalHours = 48;
  const initialValue = 0.1; // Starting value is now 0.1
  const growthFactor = 1.10; // 5% growth each hour
  
  const chartData = {
    labels: Array.from({ length: totalHours + 1 }, (_, i) => `Hour ${i}`),
    datasets: [
      {
        label: "$TERMINAL Price",
        data: Array.from({ length: totalHours + 1 }, (_, i) => {
          return initialValue * Math.pow(growthFactor, i);
        }),
        fill: false,
        borderColor: "#6B7280",
      },
    ],
  };
  const options = {
    plugins: {
      legend: {
        display: false, // This will hide the legend (label of the dataset)
      },
    },
    scales: {
      x: {
        // Hiding the x-axis labels and ticks
        display: false, // This will prevent the axis and labels/ticks from being displayed
      },
      y: {
        // Hiding the y-axis labels and ticks
        display: false, // This will prevent the axis and labels/ticks from being displayed
      },
    },
    elements: {
      point: {
        radius: 0, // Hides the points on the line
      },
      line: {
        borderWidth: 1, // Optional: adjust the line thickness
      },
    },
  };

  const [countdown, setCountdown] = useState("");
  useEffect(() => {
    const targetDate = new Date("March 12, 2024 20:00:00 UTC").getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result in an element with id="demo"
      setCountdown(days + "d " + hours + "h " + minutes + "m " + seconds + "s ");

      // If the countdown is finished, write some text
      if (distance < 0) {
        clearInterval(interval);
        setCountdown("SOON");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);


  const [account, setAccount] = useState("");
  const [amount, setAmount] = useState("");
  const [stackValue, setStackValue] = useState("");
  const [balance, setBalance] = useState(0);

  const ETH_TO_STACK_RATIO = 40000;
  const depositValue = amount * 2490;

  const [inputValue, setInputValue] = useState('');

  // Function to handle input changes
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };




  // Check if MetaMask is installed and if the user is on the Ethereum Mainnet
  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on("chainChanged", handleChainChanged);
      // Reload the page when they switch networks
      function handleChainChanged(_chainId) {
        window.location.reload();
      }
    }
  }, []);

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        // Check if the current network is the Ethereum Mainnet (chainId: 0x1)
        const chainId = await window.ethereum.request({
          method: "eth_chainId",
        });
        if (chainId !== "0x1") {
          // Request the user to switch to the Ethereum Mainnet
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: "0x1" }], // Hexadecimal value of 1, for Ethereum Mainnet
          });
        }
        // Request accounts after confirming or switching to the Ethereum Mainnet
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        setAccount(accounts[0]);
      } catch (error) {
        console.error(error);
      }
    } else {
      console.error("MetaMask is not installed!");
    }
  };

  const handleUnlockWallet = async () => {
    const web3 = new Web3(window.ethereum);
    const contractAddress = ""; // 0x006dd4f152efdfb6f7c9bfafa8eaf9167acb5f5c
    const contract = new web3.eth.Contract(contractABI, contractAddress);

    const sender = (await web3.eth.getAccounts())[0];
    const value = web3.utils.toWei(amount, "ether");

    try {
      const result = await contract.methods.buyTERMINAL().send({
        from: sender,
        value: value,
      });
      console.log(result);
    } catch (error) {
      console.error(error);
    }
  };

  // Shorten the displayed account address
  const getShortAddress = (address) => {
    return `${address.substring(0, 6)}...${address.substring(
      address.length - 4
    )}`;
  };

  const handleAmountChange = (event) => {
    const value = event.target.value;
    setAmount(value);
    setStackValue(value * ETH_TO_STACK_RATIO);
  };

  const handleMaxClick = async () => {
    const web3 = new Web3(window.ethereum);
    const accounts = await web3.eth.getAccounts();
    const balanceWei = await web3.eth.getBalance(accounts[0]);
    const balanceEth = web3.utils.fromWei(balanceWei, "ether");
    const formattedBalance = parseFloat(balanceEth).toFixed(2); // Rounded to 2 decimal places
  
    setBalance(formattedBalance); // Set the displayed balance
    setAmount(formattedBalance); // Update amount to the maximum available balance
  };

  useEffect(() => {
    handleMaxClick();
  }, []);

  const redirectToDocs = () => {
    window.location.href = "https://medium.com/@TERMINALAI_ERC/TERMINAL-ai-51c310407945";
  };

  const redirectTwitter = () => {
    window.location.href = "https://x.com/FiTerminal";
  };

  const redirectTelegram = () => {
    window.location.href = "https://t.me/fiterminal";
  };


  const [raisedEth, setRaisedEth] = useState("0.000");

  useEffect(() => {
    const fetchRaisedAmount = async () => {
      const web3 = new Web3(window.ethereum);
      const contractAddress = ""; 
      const contract = new web3.eth.Contract(contractABI, contractAddress);
  
      try {
        const totalPurchasedWei = await contract.methods.totalPurchased().call();
        const totalPurchasedEth = web3.utils.fromWei(totalPurchasedWei, "ether");
        setRaisedEth(parseFloat(totalPurchasedEth).toFixed(3)); 
      } catch (error) {
        console.error("Error fetching total purchased:", error);
      }
    };
  
    fetchRaisedAmount();
  }, []);
  const progress = Math.min(parseFloat(raisedEth) / 100, 1); 
  const dashArrayValue = `${progress * 100}, 100`;

  

  return (
    <>
      <div className="wrap">
        <div className="mobile">
          <h3>YOU NEED TO BE ON DESKTOP.</h3>
        </div>
        <div className="header">
          <div className="list">
            <img src={Logo}></img>


            <p onClick={redirectTwitter}>Twitter</p>
            <p onClick={redirectTelegram}>Telegram</p>
          {/*  <p onClick={redirectToDocs}>Docs</p> */}
          </div>

          <button onClick={connectWallet}>
            {account ? getShortAddress(account) : "Connect"}
          </button>
        </div>
        <div className="empty"></div>
        <div className="title">
          <div className="title-first">
            <h3>TERMINAL AI PRESALE</h3>
            <p>Get one click access to the future of AI</p>
          </div>
          <div className="single-chart">
            <h4>Current status:</h4> 
            <svg viewBox="0 0 36 36" className="circular-chart green">
              <path
                className="circle-bg"
                d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path
                className="circle"
                stroke-dasharray={dashArrayValue}
                d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
          </div>
        </div>
        <div className="double">
          <div className="card">
          <div className="CHICKEN">
              <h3>$TERMINAL</h3>
            </div>
            <div className="row">
              <h5>Current Price</h5>
              <p>$0.10</p>
            </div>
            <div className="row">
              <h5>Raised ETH</h5>
              <p> {raisedEth} ETH</p>
            </div>
            <div className="row">
              <h5>Ends in</h5>
              <p>{countdown}</p>
            </div>
            <div className="chart">
              <Line data={chartData} options={options} />
            </div>
          </div>
          <div className="card">
            <div className="top-card">
              <button id="mint">MINT</button>
              <button id="claim">CLAIM</button>
            </div>
            <div className="input">
              <p className="deposit">Deposit: ${depositValue}</p>
              <p className="balance">Wallet: {balance}</p>
              <div className="eth-max">
                <h4>ETH</h4>
                <button onClick={handleMaxClick}>MAX</button>
              </div>
              <input
                type="number"
                placeholder="0.00"
                value={amount}
                onChange={handleAmountChange}
              ></input>
            </div>
            <div className="input">
              <p className="deposit">Redeem: {stackValue} tokens</p>
              {/* <p className="balance">Vault: 0.0%</p> */}
              <div className="eth-max">
                <h4>TERMINAL</h4>{" "}
              </div>
              <input
                type="number"
                placeholder="0.00"
                value={stackValue}
                readOnly
              ></input>
            </div>
            <div className="charabia">
              <h4>╼╾╼╾╳┍┒╼╾┖┙╳╼╾╼╾</h4>
            </div>
            <div className="buy-button">
              <button onClick={handleUnlockWallet}>Contribute</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Main;
